module.exports = __webpack_public_path__ + "components/bookings-online-payment-method/static/maestro-a145843c8bcfe155525a77c73f1e06f8.svg";